import React from 'react';
import Link from 'next/link';
import { Building2, ArrowRight, ShieldCheck } from 'lucide-react';

const featured: {
  id: string;
  org: string;
  title: string;
  desc: string;
  raised: number;
  goal: number;
  color: string;
}[] = [];

export default function FeaturedCampaigns() {
  if (featured.length === 0) {
    return (
      <div className="mb-12">
        <div className="flex items-center justify-between mb-6">
          <div>
            <p className="section-label mb-1">Partner Campaigns</p>
            <h2 className="font-display text-2xl font-700 text-gray-900">Featured Charity Campaigns</h2>
          </div>
          <Link href="/charity-partner-portal" className="text-sm text-teal-600 font-semibold hover:text-teal-700 flex items-center gap-1">
            All campaigns <ArrowRight size={14} />
          </Link>
        </div>
        <div className="card p-10 text-center text-gray-400">
          <Building2 size={32} className="mx-auto mb-3 opacity-40" />
          <p className="text-sm">No featured campaigns yet. Charity partners can list campaigns via the partner portal.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mb-12">
      <div className="flex items-center justify-between mb-6">
        <div>
          <p className="section-label mb-1">Partner Campaigns</p>
          <h2 className="font-display text-2xl font-700 text-gray-900">Featured Charity Campaigns</h2>
        </div>
        <Link href="/charity-partner-portal" className="text-sm text-teal-600 font-semibold hover:text-teal-700 flex items-center gap-1">
          All campaigns <ArrowRight size={14} />
        </Link>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {featured?.map((f) => {
          const pct = Math.round((f?.raised / f?.goal) * 100);
          return (
            <div key={f?.id} className="card p-6 flex gap-5">
              <div className={`flex-shrink-0 w-12 h-12 ${f?.color} rounded-xl flex items-center justify-center`}>
                <Building2 size={22} className="text-white" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-sm font-semibold text-gray-900">{f?.org}</span>
                  <span className="badge-verified">
                    <ShieldCheck size={10} />
                    Verified
                  </span>
                </div>
                <h3 className="font-display text-base font-700 text-gray-900 mb-2">{f?.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed mb-4">{f?.desc}</p>
                <div className="flex justify-between text-xs mb-1.5">
                  <span className="font-mono font-bold text-teal-600">£{f?.raised?.toLocaleString()}</span>
                  <span className="text-gray-400">of £{f?.goal?.toLocaleString()} goal</span>
                </div>
                <div className="progress-bar mb-3">
                  <div className="progress-fill" style={{ width: `${pct}%` }} />
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-gray-500">{pct}% funded</span>
                  <Link href="/sign-up-login-screen" className="text-sm font-semibold text-teal-600 hover:text-teal-700 flex items-center gap-1">
                    Support this campaign <ArrowRight size={13} />
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}